<template>
    		<!-- Testimonial  Section -->
		<section class="testimonial-section-eight ">
			<div class="container">
				<div class="section-heading heading-eight">
					<div class="row align-items-center">
						<div class="col-md-12 aos aos-init aos-animate text-center" data-aos="fade-up">
							<h2>What Jobholders Say’s About Us </h2>
							<p>Highlight the most popular owners</p>
						</div>
					</div>
				</div>
				<div class="testi-carousel ">
					<div class="job-slider owl-carousel owl-theme owl-loaded owl-drag">
						<div class="owl-stage-outer">
							<div class="owl-stage">
								<Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
					        	<Slide v-for="item in IndexEightTestimonial" :key="item.id">
								<div class="owl-item cloned">
									<div class="testi-widget-eight aos aos-init aos-animate" data-aos="fade-up">
										<div class="test-details">
											<div class="icon-blk">
												<img :src="require(`@/assets/img/profiles/${item.image}`)"
													alt="Dreamstrip Testimonials">
											</div>
										</div>
										<div class="testi-content">
											<p>{{ item.title }}
											</p>
										</div>
										<div class="testi-location">
											<h4>{{ item.name }}</h4>
											<p>{{ item.content }}</p>
										</div>
									</div>
								</div>
								 </Slide>
                                <template #addons>
                                    <Navigation />
                                </template>
								 </Carousel>
							</div>
						</div>
						<div class="owl-dots disabled"></div>
					</div>
				</div>
				<div class="testimonial-nav">

				</div>
			</div>
			<div class="test-bg">
				<img src="@/assets/img/test-bg.png" class="img-fluid" alt="img">
			</div>
		</section>
		<!-- /Testimonial Section -->
    </template>

	<script>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import IndexEightTestimonial from '@/assets/json/indexEightTestimonial.json'
export default {
    data() {
        return {
            IndexEightTestimonial: IndexEightTestimonial,
            settings: {
				itemsToShow: 1,
				snapAlign: "center"
			},
			breakpoints: {
                575: {
					itemsToShow: 2,
					snapAlign: "center"
				},
				// 700px and up
				767: {
					itemsToShow: 2,
					snapAlign: "center"
				},
                // 991 and up
                991: {
                    itemsToShow: 3,
					snapAlign: "center"
                },
				// 1024 and up
				1024: {
					itemsToShow: 3,
					snapAlign: "start"
				}
			},
        }
    },
    components: {
			Carousel,
			Slide,
			Pagination,
			Navigation,
		},
}
</script>